import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private keycloakService: KeycloakService) {}

  isAdminRoles(roles?: string[]): boolean {
    if (!roles) {
      roles = this.keycloakService.getUserRoles();
    }
    return roles.some((str) => ADMIN_ROLES.includes(str));
  }

  isDoctor(roles?: string[]): boolean {
    if (!roles) {
      roles = this.keycloakService.getUserRoles();
    }
    return roles.some((str) => DOCTOR_RULE.includes(str));
  }
}

export const DOCTOR_RULE = ['MEDICO'];
export const ADMIN_ROLES = ['MEDICO', 'GENETISTA', 'INFERMIERE'];
export const PATIENT_ROLES = ['PAZIENTE'];
